import React, { useState } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'

import Page from 'src/comps/Page'
import { trpc } from 'src/utils/trpc'
import { PropertyProvider } from 'src/context/property'
import { getServerSideProps as getServerSidePropsHandler } from 'src/pages/hotel/[country]/[slug]/server'
import { ConfigType } from 'src/types/config'
import { PropertyAPIResponse as PropertyType } from 'src/types/property'
import Content from 'src/pages/hotel/[country]/[slug]/Content'
import { ListOfAncillary } from '@s4l/stayforlong/booking/ListOfAncillary'
import { ListOfBanner } from '@s4l/stayforlong/marketing/ListOfBanner'

export const pageId = 'detail'

interface IHotelPageProps {
  config: ConfigType
  property: PropertyType
  location: { country: string; type: string; slug: string }
  ancillariesJSON: ReturnType<ListOfAncillary['toJSON']>
  bannersJSON?: ReturnType<ListOfBanner['toJSON']>
}

function HotelPage({
  property,
  config,
  location,
  ancillariesJSON,
  bannersJSON,
}: Readonly<IHotelPageProps>) {
  const [queryClient] = useState(() => new QueryClient())
  const [trpcClient] = useState(() =>
    trpc.createClient({
      url: `${process.env.NEXT_PUBLIC_PROTOCOL}${config.host}/${process.env.NEXT_PUBLIC_TRPC_URL}`,
    })
  )

  const contentLocation = {
    ...location,
    city: property.city,
    purchaseId: '',
  }

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <PropertyProvider value={property}>
          <Page
            key={property?.id}
            config={config}
            pageId={pageId}
            trackingData={{ propertyId: property?.id }}
          >
            <Content
              property={property}
              location={contentLocation}
              ancillariesJSON={ancillariesJSON}
              bannersJSON={bannersJSON}
            />
          </Page>
        </PropertyProvider>
      </QueryClientProvider>
    </trpc.Provider>
  )
}

export const getServerSideProps = getServerSidePropsHandler

HotelPage.pageId = pageId
HotelPage.pagePathView = '/hotel/[country]/[slug]'

export default HotelPage
